import React from 'react';
// import { Input } from 'components/Atoms';
import Icon, { SearchIcon } from 'components/Atoms/Icon';
import classnames from 'classnames';
import InputV2 from 'components/Atoms/Input/v2';
import './styles.scss';

const SearchInputV2 = ({ className, ...rest }) => {
  return (
    <InputV2
      {...rest}
      prefix={<Icon component={SearchIcon} className="my-search-icon" />}
      className={classnames('search-input-v2', className)}
    />
  );
};

export default SearchInputV2;
